import { LocationInfo, PlayerInfo } from "../api/copenhunt/v1/copenhunt_pb";

export const pickId = () => {
  return (Math.random() + 1).toString(36).substring(7);
};

export const getPlayersByTeam = (
  playerInfos: PlayerInfo[],
  teamIds: string[]
) => {
  const playersByTeam = playerInfos.reduce((acc, player) => {
    if (!acc[player.teamId]) {
      acc[player.teamId] = [];
    }
    acc[player.teamId].push(player);
    return acc;
  }, {} as Record<string, PlayerInfo[]>);

  for (const teamId of teamIds) {
    if (playersByTeam[teamId] === undefined) {
      playersByTeam[teamId] = [];
    }
  }

  return playersByTeam;
};

export enum Color {
  color1 = "color1",
  color2 = "color2",
  color3 = "color3",
  color4 = "color4",
  color5 = "color5",
  color6 = "color6",
  color7 = "color7",
  color8 = "color8",
  color9 = "color9",
  color10 = "color10",
  color11 = "color11",
}

export const colorHexMap: { [key in Color]: string } = {
  [Color.color1]: "#ff4f81",
  [Color.color2]: "#5b7286",
  [Color.color3]: "#00aeff",
  [Color.color4]: "#ffc168",
  [Color.color5]: "#05635c",
  [Color.color6]: "#b84592",
  [Color.color7]: "#8e43e7",
  [Color.color8]: "#ff6c5f",
  [Color.color9]: "#3369e7",
  [Color.color10]: "#2dde98",
  [Color.color11]: "#1cc7d0",
};

export enum Shape {
  Square = "Square",
  Triangle = "Triangle",
  Star = "Star",
  Pentagon = "Pentagon",
  Hexagon = "Hexagon",
  Ellipse = "Ellipse",
  Diamond = "Diamond",
  Heart = "Heart",
  Arrow = "Arrow",
}

export const shapeSvgMap: { [key in Shape]: string } = {
  [Shape.Square]: `<rect x="8" y="8" width="20" height="20" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Triangle]: `<polygon points="18,5 30,30 6,30" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Star]: `<polygon points="18,2 22,14 34,14 24,22 28,34 18,26 8,34 12,22 2,14 14,14" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Pentagon]: `<polygon points="18,5 30,12 25,30 11,30 6,12" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Hexagon]: `<polygon points="18,5 30,12 30,24 18,31 6,24 6,12" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Ellipse]: `<ellipse cx="18" cy="18" rx="12" ry="8" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Diamond]: `<polygon points="18,5 30,18 18,31 6,18" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Heart]: `<path d="M18 30 C10 20, 2 12, 18 5 C34 12, 26 20, 18 30 Z" fill="{color}" stroke="white" stroke-width="3" />`,
  [Shape.Arrow]: `<polygon points="18,5 28,18 22,18 22,30 14,30 14,18 8,18" fill="{color}" stroke="white" stroke-width="3" />`,
};

const colorValues = Object.values(Color) as Color[];

export const getTeamColors = (teamIds: string[]) => {
  const locationColors = {} as Record<string, Color>;
  teamIds.forEach((id, index) => {
    locationColors[id] = colorValues[index];
  });
  return locationColors;
};

const shapeValues = Object.values(Shape) as Shape[];

export const getObjectiveShapes = (locations: LocationInfo[]) => {
  const objectiveIds = locations.map((location) => location.id);
  objectiveIds.sort();

  const objectiveShapes = {} as Record<string, Shape>;
  objectiveIds.forEach((id, index) => {
    objectiveShapes[id] = shapeValues[index];
  });
  return objectiveShapes;
};

export const getTeamNumbers = (teamIds: string[]) => {
  const teamNumbers = {} as Record<string, number>;
  teamIds.forEach((id, index) => {
    teamNumbers[id] = index;
  });

  return teamNumbers;
};

export const getTeamIconSvg = (
  color: Color,
  teamNumber: number,
  shape: Shape | null
) => {
  const hex = colorHexMap[color];
  const objectiveIcon = shape
    ? `<g transform="translate(24, 0) scale(0.4)">
         ${shapeSvgMap[shape].replace(
           "{color}",
           "#000000"
         )} <!-- Example: Red color -->
       </g>`
    : "";
  const circle = `<circle cx="18" cy="18" r="10" fill="${hex}" stroke="white" stroke-width="3" />`;

  const teamNumberIcon = `<text
    x="18" 
    y="22" 
    text-anchor="middle" 
    font-size="12" 
    fill="white" 
    font-weight="bold"
  >
  ${teamNumber}
  </text>`;

  return `
    ${circle}
    ${teamNumberIcon}
    ${objectiveIcon}
    `;
};
